import { Card, Typography } from 'antd';
import { PropsWithChildren } from 'react';

export const VendorMigrationSection: React.FC<PropsWithChildren> = ({ children }) => (
  <Card className="mt-5 bg-gray-50" title="Vendor Migration">
    <Typography.Paragraph className="!mb-3 text-sm text-gray-700">
      Use this internal workflow to preview and execute orphan-vendor migration from a selected source vendor to a
      target vendor.
    </Typography.Paragraph>
    {children}
  </Card>
);
